<template>
  <div class="mask">
    <div class="replyPopup">
      <h3>留言</h3>

      <textarea :placeholder="placeholder" :value="value" @input="$emit('input', $event.target.value)"/>

      <div class="buttons">
        <button @click="cancel">取消</button>
        <button id="send" @click="send">提交</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cancel: {
      type: Function,
      default: () => console.log('ReplyPopup.Cancel')
    },

    send: {
      type: Function,
      default: () => console.log('ReplyPopup.Send')
    },

    value: {
      type: String,
      default: ''
    },

    placeholder: [String]
  }
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../../style/main";

$global-width: 750;

textarea::-webkit-input-placeholder {
  font-size: rem(26);
  color: #bdbdbd;
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 999;
  background-color: rgba(0,0,0,.6);
}

.replyPopup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  width: rem(660);
  text-align: center;
  border-radius: rem(8);
  background-color: #fff;
  overflow: hidden;

  h3 {
    margin-top: rem(30);
    color: #666;
    font-size: rem(34);
    margin-bottom: rem(30);
  }

  textarea {
    resize: none;
    height: rem(125);
    width: rem(580);
    margin: 0 auto;
    margin-bottom: rem(53);
    padding: rem(10) rem(15);
    color: #000;
    font-size: rem(26);
    line-height: rem(30);
    border: rem(1) solid #d1d1d1;
    border-radius: rem(4);

    &:-webkit-input-placeholder {
      font-size: rem(26);
      line-height: rem(30);
    }
  }

  .sep {
    height: rem(2);
    width: rem(630);
    margin: 0 auto;
    border: none;
    outline: none;
    background-color: #E4E4E4;
  }

  .buttons {
    position: relative;
    height: rem(110);
    width: 100%;
    border-top: 1px solid #E4E4E4;

    button {
      width: 50%;
      color: #999;
      font-size: rem(32);
      line-height: rem(110);
      background-color: #fff;
      border: none;
      outline: none;
      box-sizing: border-box;

      &:first-child {
        border-right: 1px solid #E4E4E4;
      }
    }

    #send {
      color: $globalColor;
    }
  }
}
</style>
